import { Link } from "react-router-dom";
import { CONTACT, JOIN } from "@/data/content";
import { scrollToId } from "@/components/site/SmoothScroll";

const EXPLORE = [{ id: "services", label: "Services" }, { id: "how", label: "How it works" }, { id: "contact", label: "Contact" }];

export default function Footer() {
  return (
    <footer className="relative bg-[#0B0424] text-white overflow-hidden grain" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10 relative">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="inline-block rounded-2xl bg-white px-5 py-4">
              <img src="/img-health-logo-trim.png" alt="IMG Health" className="h-10 w-auto" />
            </div>
            <p className="mt-6 text-white/75 max-w-sm leading-relaxed">Building a connected healthcare ecosystem that brings patients, providers, insurers, and suppliers together through one seamless, integrated network.</p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono-x text-[11px] uppercase tracking-[0.22em] text-[#ff8fbf] mb-4">Explore</p>
            <ul className="space-y-2">
              {EXPLORE.map((l) => (
                <li key={l.id}><button onClick={() => scrollToId(l.id)} data-testid={`footer-${l.id}-link`} className="text-white/80 hover:text-white transition-colors">{l.label}</button></li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono-x text-[11px] uppercase tracking-[0.22em] text-[#ff8fbf] mb-4">Join us</p>
            <ul className="space-y-2">
              {JOIN.map((j) => (
                <li key={j.type}><Link to={`/join/${j.type}`} data-testid={`footer-${j.type}-link`} className="text-white/80 hover:text-white transition-colors">{j.label}</Link></li>
              ))}
            </ul>
            <ul className="mt-8 space-y-1.5 text-sm" data-testid="footer-contact">
              {CONTACT.map((c) => (
                <li key={c.id}><span className="text-white/60">{c.label}: </span>
                  <a href={c.href} data-testid={`footer-contact-${c.id}`} className="text-white hover:text-[#ff8fbf] transition-colors">{c.value}</a></li>
              ))}
            </ul>
          </div>
        </div>
        <p aria-hidden className="mt-16 font-display font-extrabold leading-none tracking-tighter text-[18vw] md:text-[12vw] text-white/[0.06] select-none whitespace-nowrap">
          IMG Health
        </p>
        <div className="mt-6 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 justify-between text-xs text-white/60">
          <p>© {new Date().getFullYear()} IMG Health. All rights reserved.</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white transition-colors">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
